module.exports = __webpack_public_path__ + "static/media/1_A1_04.91e3f2d3.png";